import { useNavigate } from "@tanstack/react-router";
import { Search } from "lucide-react";
import { type FormEvent, useState } from "react";
import { fr } from "@/i18n/fr";

interface SearchFormProps {
	/** The hero field of the landing page: 56px pill with its button. */
	hero?: boolean;
	initial?: string;
	/** Called instead of navigating to the catalogue. */
	onChange?: (q: string) => void;
}

/** One search field that lands on the catalogue (`/catalogue?q=`). */
export function SearchForm({ hero, initial = "", onChange }: SearchFormProps) {
	const navigate = useNavigate();
	const [value, setValue] = useState(initial);
	const submit = (e: FormEvent) => {
		e.preventDefault();
		if (onChange) return;
		const q = value.trim();
		navigate({ to: "/catalogue", search: q ? { q } : {} });
	};
	return (
		<search>
			<form
				onSubmit={submit}
				className={`ui-field ${hero ? "h-14 rounded-pill pr-2 pl-5 shadow-sm" : ""}`}
			>
				<Search
					aria-hidden="true"
					className="size-5 shrink-0 text-fg-muted"
					strokeWidth={1.75}
				/>
				<input
					type="search"
					aria-label={fr.searchLabel}
					placeholder={fr.searchPlaceholder}
					value={value}
					onChange={(e) => {
						setValue(e.target.value);
						onChange?.(e.target.value);
					}}
					className={`h-full min-w-0 flex-1 bg-transparent outline-none placeholder:text-fg-muted ${hero ? "text-[17px]" : ""}`}
				/>
				{hero && (
					<button
						type="submit"
						className="ui-btn-primary hidden h-10 rounded-pill sm:inline-flex md:h-10"
					>
						{fr.landing.search}
					</button>
				)}
			</form>
		</search>
	);
}
